// Reusable icon button styles for consistent hover interactions

export const baseIconButtonSx = {
  borderRadius: '50%',
  transition: 'all 0.15s ease-out',
};

// Neutral hover - background circle (for utility actions like reload, settings)
export const neutralHoverSx = {
  ...baseIconButtonSx,
  '&:hover': {
    backgroundColor: (theme: any) => theme.palette.mode === 'dark'
      ? 'rgba(232, 234, 237, 0.08)'
      : 'rgba(0, 0, 0, 0.04)',
  },
};

// Constructive hover - blue color only (for positive actions like join, show)
export const constructiveHoverSx = {
  transition: 'all 0.15s ease-out',
  '&:hover:not(:disabled)': {
    color: 'var(--accent-primary)',
  },
};

// Destructive hover - red color only (for delete actions)
export const destructiveHoverSx = {
  transition: 'all 0.15s ease-out',
  '&:hover:not(:disabled)': {
    color: 'var(--status-old)',
  },
};
